import React from 'react';
import { ChevronLeft } from 'lucide-react';

interface VideoViewProps {
    url: string;
    title: string;
    onBack: () => void;
}

const VideoView: React.FC<VideoViewProps> = ({ url, title, onBack }) => {
    const getEmbedUrl = (url: string) => {
        if (url.includes('youtube.com') || url.includes('youtu.be')) {
            const videoId = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([^?&]+)/)?.[1];
            return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
        }
        if (url.includes('vimeo.com')) {
            const videoId = url.match(/vimeo\.com\/(\d+)/)?.[1];
            return videoId ? `https://player.vimeo.com/video/${videoId}` : null;
        }
        return null; // fallback or handle other types
    };

    const embedUrl = getEmbedUrl(url);

    return (
        <div className="flex flex-col h-full bg-black animate-in fade-in duration-300">
            <header className="px-5 py-4 flex items-center gap-3 shrink-0 bg-slate-900/50 backdrop-blur-md border-b border-white/10 text-white z-10">
                <button
                    onClick={onBack}
                    className="w-9 h-9 flex items-center justify-center bg-white/10 rounded-lg hover:bg-white/20 transition-all shrink-0"
                >
                    <ChevronLeft size={18} />
                </button>
                <h3 className="text-base font-bold truncate">{title}</h3>
            </header>

            <div className="flex-1 flex items-center justify-center p-4 sm:p-10">
                {embedUrl ? (
                    <div className="w-full max-w-5xl aspect-video bg-black rounded-2xl overflow-hidden shadow-2xl ring-1 ring-white/10">
                        <iframe
                            src={embedUrl}
                            className="w-full h-full"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        />
                    </div>
                ) : (
                    <div className="text-center text-white/50">
                        <p>재생할 수 없는 영상입니다.</p>
                        <a href={url} target="_blank" rel="noreferrer" className="text-indigo-400 hover:underline mt-2 inline-block">원본 링크 열기</a>
                    </div>
                )}
            </div>
        </div>
    );
};

export default VideoView;
